module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail4-16e0c3af739ac1c09989a3d7fbde9350.jpg";